module.exports = __webpack_public_path__ + "img/download.9438abd9.svg";